// *** QBK Validation & Data Injection Script ***
// 1. Validates fields before the bundle button works.
// 2. INTERCEPTS the network request to ensure details are saved to the cart.

(function() {
    "use strict";

    // --- CONFIGURATION ---
    const BUNDLE_BUTTON_SELECTOR = '.qbk-bundle__action-btn';
    const ERROR_MESSAGE = "Please fill in all required delivery and contact details.";
    
    // Define fields to validate AND capture
    // The script only validates fields that actually exist on the current page.
    const FIELDS = [
        { label: "Delivery Date",   selector: '#ship-date', type: 'text', propKey: "Delivery Date" },
        { label: "Buyer Phone",     selector: 'input[name="Phone No"]', type: 'text', propKey: "Phone No" },
        { label: "Recipient Phone", selector: 'input[name="Recipient Ph no"]', type: 'text', propKey: "Recipient Ph no" },
        { label: "Time Slot",       selector: 'input[name="time of delivery"]', type: 'radio', propKey: "Time of Delivery" },
        { label: "Box Color",       selector: 'input[name="box color"]', type: 'radio', propKey: "Box Color" },
        { label: "Flower Color",    selector: 'input[name="flower clr"]', type: 'radio', propKey: "Flower Color" },
        { label: "Wrap Color",      selector: 'input[name="wrap clr"]', type: 'radio', propKey: "Wrap Color" }
    ];

    // Helper: Check if a visual text value is a "placeholder" (invalid)
    function isPlaceholder(text) {
        if (!text) return true;
        const t = text.trim().toLowerCase();
        // Checks for specific phrases or if it starts with "choose" or "select"
        return t === '' || 
               t === '-- select time --' || 
               t.startsWith('choose') || 
               t.startsWith('select');
    }

    // --- PART 1: DATA CAPTURE ---
    // Scrapes the current values from the page to inject into the cart
    function getPageProperties() {
        const props = {};
        
        FIELDS.forEach(field => {
            let val = "";
            const inputExists = document.querySelector(field.selector);
            
            // Only attempt to capture if the field exists on the page
            if (inputExists) {
                if (field.type === 'radio') {
                    // 1. Check hidden radio first
                    const checked = document.querySelector(`${field.selector}:checked`);
                    if (checked) {
                        val = checked.value;
                    } else {
                        // 2. GPO App Text Fallback
                        const input = document.querySelector(field.selector);
                        if (input) {
                            const container = input.closest('.gpo-dropdown');
                            if (container) {
                                const textEl = container.querySelector('.selected-value, .dropdown-button__value');
                                const text = textEl ? textEl.innerText.trim() : '';
                                if (!isPlaceholder(text)) val = text;
                            }
                        }
                    }
                } else {
                    const el = document.querySelector(field.selector);
                    if (el) val = el.value || el.getAttribute('value') || "";
                }
                
                // Only add if we found a value
                if (val) {
                    props[field.propKey] = val.trim();
                }
            }
        });
        return props;
    }

    // --- PART 2: NETWORK INTERCEPTOR ---
    const originalFetch = window.fetch;
    window.fetch = function(resource, config) {
        if (resource && resource.toString().includes('/cart/add')) {
            try {
                const customProps = getPageProperties();
                console.log("🛒 Intercepting Cart Add. Injecting:", customProps);

                if (config && config.body) {
                    const body = JSON.parse(config.body);
                    if (body.items && Array.isArray(body.items)) {
                        body.items.forEach(item => {
                            item.properties = { ...item.properties, ...customProps };
                        });
                    } else if (body.id) {
                        body.properties = { ...body.properties, ...customProps };
                    }
                    config.body = JSON.stringify(body);
                }
            } catch (e) {
                console.error("⚠️ QBK Injection Error:", e);
            }
        }
        return originalFetch(resource, config);
    };

    // --- PART 3: VALIDATION LOGIC ---
    function showVisualError(targetBtn) {
        const old = document.getElementById('qbk-error-msg');
        if (old) old.remove();

        const msg = document.createElement('div');
        msg.id = 'qbk-error-msg';
        msg.innerText = ERROR_MESSAGE;
        msg.style.cssText = "background:#fce4e4; color:#cc0000; border:2px solid #cc0000; padding:10px; margin-bottom:10px; font-weight:bold; border-radius:5px; text-align:center;";
        
        targetBtn.parentNode.insertBefore(msg, targetBtn);

        setTimeout(() => {
            msg.style.opacity = '0';
            setTimeout(() => msg.remove(), 500);
        }, 5000);
    }

    function checkAllFields() {
        let allValid = true;
        FIELDS.forEach(field => {
            // Skip validation if the field doesn't exist on this page
            const inputExists = document.querySelector(field.selector);
            if (!inputExists) return;

            let isValid = false;
            
            if (field.type === 'radio') {
                // Check Radio Input
                const checked = document.querySelector(`${field.selector}:checked`);
                
                // Check Visual Text (Scoped to specific container)
                let hasVisualValue = false;
                const input = document.querySelector(field.selector);
                if (input) {
                    const container = input.closest('.gpo-dropdown');
                    if (container) {
                        const textEl = container.querySelector('.selected-value, .dropdown-button__value');
                        const text = textEl ? textEl.innerText.trim() : '';
                        if (!isPlaceholder(text)) hasVisualValue = true;
                    }
                }

                if (checked || hasVisualValue) isValid = true;

            } else {
                const el = document.querySelector(field.selector);
                // Basic non-empty check for text inputs
                if (el && (el.value || el.getAttribute('value') || "").trim().length > 0) isValid = true;
            }

            // Highlight Logic
            const el = document.querySelector(field.selector);
            if (el) {
                const wrapper = el.closest('.gpo-input-wrap, .gpo-dropdown, .date-selector') || el;
                
                if (!isValid) {
                    allValid = false;
                    if(wrapper) wrapper.style.border = "2px solid red";
                } else {
                    if(wrapper) wrapper.style.border = "";
                }
            }
        });
        return allValid;
    }

    // Global Listener
    document.body.addEventListener('click', function(e) {
        const btn = e.target.closest(BUNDLE_BUTTON_SELECTOR);
        if (btn) {
            if (!checkAllFields()) {
                e.preventDefault();
                e.stopImmediatePropagation();
                showVisualError(btn);
            } else {
                const old = document.getElementById('qbk-error-msg');
                if (old) old.remove();
            }
        }
    }, true);

})();